import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'workingStatus'
})
export class WorkingStatusPipe implements PipeTransform {

  transform(value: number, ...args: any[]): string {
    let result: string;
    args[0].filter(item => { item.id === value ? result = item.localizedText : null; });
    return result;
  }
}
